/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

const Fixer: React.FC = () => {
  return <div></div>
}

export { Fixer }
